<div class="date-picker">
  <div class="w-100">
    <div class="px-0 input-group-text">
      <input #hiddenInput="ngbDatepicker" type="hidden" ngbDatepicker [dayTemplate]="days" [footerTemplate]="footer" [ngModel]="ngbDate"
        [startDate]="ngbDate" [firstDayOfWeek]="7" [markDisabled]="isDateDisabled" (dateSelect)="onDateChanged($event)"
        [autoClose]="true" [positionTarget]="dtinput" [placement]="placement" />
      <input #dtinput type="text" class="form-control fw-bold date-text" [readonly]="readonly"
        (change)="onModelDateChanged()" (input)="onModelDateChanged()" [(ngModel)]="modelDate" [mask]="format"
        [ngClass]="{'is-invalid': errors!=='', 'border-dark': errors === ''}" />
      @if (displayValidationErrors) {
<span class="validation-icon"></span>
}
      <button aria-label="Select a Date" #buttonEl
        [ngClass]="{'border-danger': errors!=='', 'border-dark': errors === ''}"
        class="btn rounded-0 calendar-btn" [disabled]="readonly" (click)="hiddenInput.toggle(); getCommentDates();"
        type="button"><span class="calendar icon"></span></button>
    </div>
  </div>
</div>

@if (errors !== '' && displayValidationErrors) {
<small class="text-danger">{{errors}}</small>
}

<ng-template #footer>
  <div class="footer m-0 m-y-1 p-1 p-b-2">
    <div class="d-inline-flex flex-grow-1">
      <button class="today-btn" (click)="changeToToday(hiddenInput)">{{localize(langSection.DatePicker,
        langText.Today)}}</button>
      <button class="clear-btn" (click)="clearDate()">{{localize(langSection.DatePicker, langText.Clear)}}</button>
    </div>
    <div class="d-inline-flex flex-row">
      <button class="close-btn" (click)="hiddenInput.close()">{{localize(langSection.DatePicker,
        langText.Close)}}</button>
    </div>
  </div>
</ng-template>

<ng-template #days let-date let-currentMonth="currentMonth" let-currentYear="currentYear" let-selected="selected" let-disabled="disabled" let-focused="focused">
  <div class="ngb-dp-content ngb-dp-day m-0" [class.bg-primary]="selected" [class.outside]="disabled || date.month !== currentMonth" [class.focused]="focused">
    {{date.day}}
  </div>
  <span class="dp-meatball">
    @if (hasUnreadComments(date)) {
<span class="comments-indicator icon"></span>
}
  </span>
</ng-template>